import React from 'react';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import { useStyles } from './style';

interface RichTextWrapperProps {
  text: RichTextBlock[];
}

const RichTextWrapper: React.FC<RichTextWrapperProps> = ({ text }) => {
  const classes = useStyles();
  if (!text) return null;

  return (
    <div className={classes.richText}>
      <RichText render={text} />
    </div>
  );
};

export default RichTextWrapper;
